import * as React from "react";
const SvgIcHome = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M1 10V23H23V10L12 1L1 10ZM9 20H4V11.5L12 5L20 11.5V20H15V14H9V20Z" fill="currentColor" /></svg>;
export default SvgIcHome;